window.addEventListener('DOMContentLoaded', (event) => {                 
  const btnArr = [];
  let btn = document.querySelectorAll("[href='/pages/3-0-series']");
  btnArr.push(btn);
  var btnsArr = Array.from(btn);
  const text = "EXPLORE IN DEPTH"; 
  let btnSecondary = btnsArr[1];
  if (btnSecondary) {
  	btnSecondary.classList.add("Button--secondary");
  }
});

$(document).ready(function(){
  $(document).on('click', function (event) {
    if (!$(event.target).closest('#open_drawer').length) {
      $("#beacon-container").show();
    }
    else{
      $("#beacon-container").hide();
    }
  });
});